import React, { useState } from "react";

const SUGGESTIONS = [
  "Tell me about yourself.",
  "What has Anand built?",
  "Tell me about Comet Hunter.",
];

const AMAWidget = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const BACKEND = process.env.REACT_APP_RAG_URL;

  const askBackend = async (q) => {
    const query = q || question;
    if (!query.trim()) return;
    setQuestion(query);
    setLoading(true);
    setAnswer("");

    try {
      const res = await fetch(`${BACKEND}/ask`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query }),
      });
      const data = await res.json();
      setAnswer(data.answer);
    } catch (err) {
      console.error(err);
      setAnswer("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") askBackend();
  };

  return (
    <div>
      {/* Input row */}
      <div className="flex flex-col md:flex-row items-center gap-4">
        <input
          className="flex-grow w-full px-4 py-2 rounded bg-slate-800 text-white border border-slate-700 focus:outline-none focus:border-teal-300"
          placeholder="e.g. Tell me about your technical background."
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          onClick={() => askBackend()}
          disabled={loading}
          className="border-2 border-teal-300 px-6 py-2 font-mono text-teal-300 shadow-teal-300 shadow-md hover:shadow-sm hover:shadow-teal-300 whitespace-nowrap"
        >
          {loading ? "Thinking..." : "Ask"}
        </button>
      </div>

      {/* Suggestion chips */}
      {!answer && (
        <div className="flex flex-wrap gap-2 pt-4">
          {SUGGESTIONS.map((s) => (
            <button
              key={s}
              onClick={() => askBackend(s)}
              className="text-sm font-mono text-slate-400 border border-slate-600 px-3 py-1 rounded-full hover:border-teal-300 hover:text-teal-300 transition-colors duration-200"
            >
              {s}
            </button>
          ))}
        </div>
      )}

      {/* Answer */}
      {answer && (
        <div className="mt-6 bg-slate-800 text-slate-200 rounded p-4 text-base leading-relaxed">
          {answer}
        </div>
      )}
    </div>
  );
};

export default AMAWidget;
